import React, { useCallback, useState } from 'react'

import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'
import EnterpriseAIUseCaseCard from './EnterpriseAIUseCaseCard'

const EnterpriseAIUseCases = ({ lang }) => {
  const { useCases } = getEnterpriseAIContent(lang)
  const [activeTab, setActiveTab] = useState('solution')
  const cards = activeTab === 'solution' ? useCases.solution : useCases.industry

  const onKeyDown = useCallback(
    e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault()
        setActiveTab(t => (t === 'solution' ? 'industry' : 'solution'))
      }
    },
    []
  )

  return (
    <section className="enterprise-ai-use-cases" aria-labelledby="enterprise-ai-use-cases-heading">
      <div className="content container">
        <div className="enterprise-ai-use-cases__intro">
          <h2 id="enterprise-ai-use-cases-heading" className="enterprise-ai-use-cases__heading">
            {useCases.heading}
          </h2>
          <p className="enterprise-ai-use-cases__lede">{useCases.lede}</p>
        </div>
        <div
          className="enterprise-ai-use-cases__tabs"
          role="tablist"
          aria-label={useCases.heading}
          onKeyDown={onKeyDown}
        >
          <button
            type="button"
            role="tab"
            id="enterprise-ai-use-cases-tab-solution"
            className={
              'enterprise-ai-use-cases__tab' +
              (activeTab === 'solution' ? ' enterprise-ai-use-cases__tab--active' : '')
            }
            aria-selected={activeTab === 'solution'}
            aria-controls="enterprise-ai-use-cases-panel-solution"
            tabIndex={activeTab === 'solution' ? 0 : -1}
            onClick={() => setActiveTab('solution')}
          >
            {useCases.tabSolution}
          </button>
          <button
            type="button"
            role="tab"
            id="enterprise-ai-use-cases-tab-industry"
            className={
              'enterprise-ai-use-cases__tab' +
              (activeTab === 'industry' ? ' enterprise-ai-use-cases__tab--active' : '')
            }
            aria-selected={activeTab === 'industry'}
            aria-controls="enterprise-ai-use-cases-panel-industry"
            tabIndex={activeTab === 'industry' ? 0 : -1}
            onClick={() => setActiveTab('industry')}
          >
            {useCases.tabIndustry}
          </button>
        </div>
        <div
          role="tabpanel"
          id={`enterprise-ai-use-cases-panel-${activeTab}`}
          aria-labelledby={`enterprise-ai-use-cases-tab-${activeTab}`}
          className="enterprise-ai-use-cases__grid"
        >
          {cards.map(card => (
            <EnterpriseAIUseCaseCard key={card.id} card={card} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default EnterpriseAIUseCases
